const WINDOW = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

export default WINDOW;



// WEBPACK FOOTER //
// ./src/common/consts/window.js